export const AutoScreeningRoutes = {
    SetCustomerDecision: "AutoScreening/SetCustomerDecision",
    SaveAutoScreening: "AutoScreening/SaveAutoScreening",
    GetAutoScreening: "AutoScreening/GetAutoScreening",
    GetVetTasks: "AutoScreening/GetVetTasks",
    ChangeStatus: "AutoScreening/ChangeStatus",
    ReRunRules: "AutoScreening/ReRunRules",
}

export const VettingRoutes = {
    UpdateVetTaskOutcome: "Vet/UpdateVetTaskOutcome",
    ChangeVetApplicable: "Vet/ChangeVetApplicable",
    ChangeStatus: "Vet/ChangeStatus",
    ApplyForWaiver: "Vet/ApplyForWaiver",
    ReRunRules: "Vet/ReRunRules",
    SaveVettingComments: "Vet/SaveVettingComments",
    SaveVetTask: "Vet/SaveVetTask",
    GetSubtask: "Vet/GetSubtask",
    GetListItems: "Vet/GetListItems",
    GetCapResponse: "Vet/GetCapResponse",
    RecentActivity: "Vet/RecentActivity",
    SaveVet: "Vet/SaveVet",
    SaveVetCorrespondenceEmails: "Vet/SaveVetCorrespondenceEmails",
    SetCustomerDecision: "Vet/SetCustomerDecision",
    GetBusinessUnitVetAlertRecipients: "Vet/GetBusinessUnitVetAlertRecipients",
    GetVet: "Vet/GetVet",
    GetVetCorrespondenceEmails: "Vet/GetVetCorrespondenceEmails",
    GetVetRuleRunsClientModel: "Vet/GetVetRuleRunsClientModel",
    GetVetRuleRunItemsClientModel: "Vet/GetVetRuleRunItemsClientModel",
    GetVetRuleRunItemRiskClientModel: "Vet/GetVetRuleRunItemRiskClientModel",
    GetPreviouslyUsedShipManagerEmail: "Vet/GetPreviouslyUsedShipManagerEmail",
    GetVetTasks: "Vet/GetVetTasks",
    Save: "Vet",
    GetVetRequiresMoreInformationEmails: "Vet/GetVetRequiresMoreInformationEmails",
    VetActivityReportChartCounts: "Vet/VetActivityReportChartCounts",
    VetActivityReportUnits: "Vet/VetActivityReportUnits",
    VetActivityByStatus: "Vet/VetActivityByStatus",
    GetVetRequestReportInfo: "Vet/GetVetRequestReportInfo",
    GetVettingSireReport: "Vet/GetVettingSireReport",
    GetVettingSireReportAnswers: "Vet/GetVettingSireReportAnswers",
    DeleteSubtaskCorrespondence: "Vet/DeleteSubtaskCorrespondence",
    UpdateSubtaskEmailCorrespondenceEmail: "Vet/UpdateSubtaskEmailCorrespondenceEmail",
    GetOpenVetsForVessel: "Vet/GetOpenVetsForVessel"
}

export const VoyageDataSubmissionRoutes = {
    ChangeStatus: "VoyageDataSubmission/ChangeStatus",
    SaveVoyageDataSubmission: "VoyageDataSubmission/SaveVoyageDataSubmission",
    GetVoyageDataSubmission: "VoyageDataSubmission/GetVoyageDataSubmission",
    DashboardData: "VoyageDataSubmission/DashboardData",
    GetCarbonAccountingEmissionsIntensityReport: "VoyageDataSubmission/GetCarbonAccountingEmissionsIntensityReport",
    HasCaEnrollment: "VoyageDataSubmission/HasCaEnrollment",
    GetCaDashboardSettings: "VoyageDataSubmission/GetCaDashboardSettings",
    GetVoyageDataSubmissionIdIfAnyDraft: "VoyageDataSubmission/GetVoyageDataSubmissionIdIfAnyDraft",
    CurrentCaReportingPeriod: "VoyageDataSubmission/CurrentCaReportingPeriod",
    Save: "VoyageDataSubmission",
    GetVoyageDataSubmissionIdIfWasSubmittedOrCompleted: "VoyageDataSubmission/GetVoyageDataSubmissionIdIfWasSubmittedOrCompleted",
    GetVoyageDataSubmissionErrors: "VoyageDataSubmission/GetVoyageDataSubmissionErrors",
    ResolveValidationErrors: "VoyageDataSubmission/ResolveValidationErrors",
    GetLastFourSubmissionsData: "VoyageDataSubmission/GetLastFourSubmissionsData",
    GetCargoTypeDistribution: "VoyageDataSubmission/GetCargoTypeDistribution",
    ValidateAttachments: "VoyageDataSubmission/ValidateAttachments",
    GetVoyageDataSubmissionComputationErrors: "VoyageDataSubmission/GetVoyageDataSubmissionComputationErrors",
    DeleteVoyageData: "VoyageDataSubmission/DeleteVoyageData",
    GetIsNotReadyForReporting: "VoyageDataSubmission/GetIsNotReadyForReporting",
    GetVoyageDataSubmissionTotalEmissionsAndIntensity: "VoyageDataSubmission/GetVoyageDataSubmissionTotalEmissionsAndIntensity"
}

export const SafetyRatingReviewRoutes = {
    UpdateSafetyRatingReviewTaskOutcome: "SafetyRatingReview/UpdateSafetyRatingReviewTaskOutcome",
    ChangeStatus: "SafetyRatingReview/ChangeStatus",
    ReRunRules: "SafetyRatingReview/ReRunRules",
    SaveSafetyRatingReviewComments: "SafetyRatingReview/SaveSafetyRatingReviewComments",
    GetSafetyRatingReview: "SafetyRatingReview/GetSafetyRatingReview",
    GetListItems: "SafetyRatingReview/GetListItems",
    GetSafetyRatingReviewTasks: "SafetyRatingReview/GetSafetyRatingReviewTasks"
}

export const VettingRuleEntityUris = {
    VettingRuleVesselIncidents: "VettingRuleVesselIncidents",
    VettingRuleVesselPscs: "VettingRuleVesselPscs",
    VettingRuleVesselPscDeficiencies: "VettingRuleVesselPscDeficiencies",
    FBRs: "FBRs",
    VettingRuleFbrAggregate: "VettingRuleFbrAggregate",
    VettingRuleCompanyAssociations: "VettingRuleCompanyAssociations",
    VettingRuleVets: "VettingRuleVets",
    VettingRuleVesselCSSR: "VettingRuleVesselCssrReports"
}